export default "__VITE_ASSET__D3n00ECW__"